"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Persona: function() {
        return _Persona.Persona;
    },
    personaClassNames: function() {
        return _Persona.personaClassNames;
    },
    renderPersona_unstable: function() {
        return _Persona.renderPersona_unstable;
    },
    usePersonaStyles_unstable: function() {
        return _Persona.usePersonaStyles_unstable;
    },
    usePersona_unstable: function() {
        return _Persona.usePersona_unstable;
    }
});
const _Persona = require("./Persona");
